import React from 'react';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'gold' | 'red';
  children: ReactNode;
  className?: string;
}
export function Button({
  variant = 'primary',
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'relative px-8 py-4 font-bold uppercase tracking-wider transition-all duration-300 transform hover:scale-105 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-matrix text-black hover:bg-white hover:shadow-[0_0_20px_rgba(0,255,65,0.6)]',
    secondary: 'bg-transparent border border-matrix text-matrix hover:bg-matrix/10',
    gold: 'bg-gradient-to-b from-[#FFD700] to-[#B8860B] text-black border border-[#FFD700] shadow-[0_0_15px_rgba(255,215,0,0.4)] hover:shadow-[0_0_25px_rgba(255,215,0,0.6)]',
    red: 'bg-gradient-to-b from-red-600 to-red-800 text-white border border-red-500 shadow-[0_0_15px_rgba(220,38,38,0.4)] hover:shadow-[0_0_25px_rgba(220,38,38,0.6)]'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-55">
      {children}
    </button>;
}